import {
  FETCH_FDS_CARDS_START,
  FETCH_FDS_CARDS_SUCCESS,
  FETCH_FDS_CARDS_ERROR,
  ADD_FDS_CARD_START,
  ADD_FDS_CARD_SUCCESS,
  ADD_FDS_CARD_ERROR,
  UPDATE_FDS_CARD_START,
  UPDATE_FDS_CARD_ERROR,
  UPDATE_FDS_CARD_SUCCESS,
} from '../../constants/ActionTypes';

const INIT_STATE = {
  data: [],
  meta: {
    page: 1,
    pageSize: 10,
    pageTotal: 1,
  },
  loading: false,
  error: null,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case ADD_FDS_CARD_START:
    case UPDATE_FDS_CARD_START:
    case FETCH_FDS_CARDS_START: {
      return {
        ...state,
        loading: true,
      };
    }

    case ADD_FDS_CARD_ERROR:
    case UPDATE_FDS_CARD_ERROR:
    case FETCH_FDS_CARDS_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }

    case FETCH_FDS_CARDS_SUCCESS: {
      return {
        ...state,
        loading: false,
        data: action.payload,
        meta: { ...state.meta, ...action.meta },
      };
    }

    case ADD_FDS_CARD_SUCCESS: {
      return {
        ...state,
        loading: false,
        data: action.payload,
        meta: { ...state.meta, ...action.meta },
      };
    }

    case UPDATE_FDS_CARD_SUCCESS: {
      const updatedData = state.data.map(
        (fdsCard) => (
          fdsCard._id !== action.payload._id ? fdsCard : action.payload
        ),
      );
      return {
        ...state,
        loading: false,
        data: updatedData,
      };
    }

    default:
      return state;
  }
};
